@if(beginRender){
@if(!forSection){
<div class="main-search-container">
  @if(props && !props.isBreadCrumbSection){
  <app-breadcrums [breadcrumList]="DataTableSchema.breadcrums"></app-breadcrums>
  }
  <div class="layout-container">
    <!-- Left Column -->
     @if(filterSchema.AdditionalForms){
      <div class="left-panel multi-form-panel">
          <app-search-container [dynamicFormArray]="filterSchema" [props]="props"
              class="app-search-container"  [DataTableSchema]="DataTableSchema"></app-search-container>
              @if(filterSchema.AdditionalForms.isEnabled){
                <app-search-container [dynamicFormArray]="filterSchema.AdditionalForms" [props]="filterSchema.AdditionalForms.props"
                class="app-search-container" [DataTableSchema]="DataTableSchema"></app-search-container>
              }

      </div>
     }@else{
        <div class="left-panel">
          <app-search-container [dynamicFormArray]="filterSchema" [props]="props"
            class="app-search-container" [DataTableSchema]="DataTableSchema"></app-search-container>
        </div>
     }
    <!-- Right Column -->
    <div class="right-panel">
      @if(DataTableSchema){
        @if(DataTableSchema && DataTableSchema['titleSchema'] && DataTableSchema['titleSchema']['title']){
          <div class="header-row">
            <header class="data-table-title">{{DataTableSchema['titleSchema']['title']}}</header>
          </div>
        }
      <app-dynamic-data-table [DataTableSchema]="DataTableSchema" class="dynamic-table-main-container"
        [dataInput]="DataTableSchema.dataSource.length>0?DataTableSchema.dataSource:[]" [filterSchema]="filterSchema"
        [props]="props"></app-dynamic-data-table>
      }
    </div>
  </div>
</div>

}
@if(forSection){
<!-- The inline style is for making the loading indicator fit inside the container -->
<div class="section-container" style="position: relative;">

  <div [ngClass]="{'header-container-gap':DataTableSchema['isTableGap']}" class="header-container">
    <div class="header-row">
      @if(filterSchema){
        <app-search-container [dynamicFormArray]="filterSchema" [props]="props" class="app-search-container"
          [showTitle]="false" [DataTableSchema]="DataTableSchema">
        </app-search-container>
      }
      @if(DataTableSchema['isFilterListExportRequired']){
      <app-download-button class="chart-export-action" (buttonClicked)="exportTableData()"
        [tableValues]="DataTableSchema['dataSource']"
        exportMessage="{{DataTableSchema.exportConfig?.exportMessage}}"></app-download-button>
      }
    </div>
    @if(DataTableSchema['title']){
      <div class="header-row">
        <header class="data-table-title">{{DataTableSchema['title']}}</header>
      </div>
    }
  </div>
  <app-dynamic-data-table [DataTableSchema]="DataTableSchema" class="dynamic-table-main-container"
    [dataInput]="DataTableSchema['dataSource']" [props]="props" [filterSchema]="filterSchema">
  </app-dynamic-data-table>
  <app-spinner [spinnerName]="spinnerName"></app-spinner>
</div>

}
}